var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EventEmitter } from 'eventemitter3';
import { RPChatsAPIv1 } from './RPChatsAPIv1';
class RPChatsAPI extends EventEmitter {
    constructor(config) {
        super();
        this.config = config;
        this._rpChatsAPIv1 = new RPChatsAPIv1(Object.assign(Object.assign({}, this.config), { namespace: 'chats/v1' }));
        this._rpChatsAPIv1.on('internal-error', (error, params) => this.emit('v1/internal-error', error, params));
        this._rpChatsAPIv1.on('chats', (chats, params) => this.emit('v1/chats', chats, params));
        this._rpChatsAPIv1.on('chats/describe', (chat, params) => this.emit('v1/chats/describe', chat, params));
        this._rpChatsAPIv1.on('chats/members', (members, chatId, params) => this.emit('v1/chats/members', members, chatId, params));
        this._rpChatsAPIv1.on('chats/new', (chat, params) => this.emit('v1/chats/new', chat, params));
        this._rpChatsAPIv1.on('chats/edit', (chat, params) => this.emit('v1/chats/edit', chat, params));
        this._rpChatsAPIv1.on('chats/delete', (chat, params) => this.emit('v1/chats/delete', chat, params));
        this._rpChatsAPIv1.on('channels', (channels, params) => this.emit('v1/channels', channels, params));
        this._rpChatsAPIv1.on('channels/describe', (channel, params) => this.emit('v1/channels/describe', channel, params));
        this._rpChatsAPIv1.on('channels/members', (members, channelId, params) => this.emit('v1/channels/members', members, channelId, params));
        this._rpChatsAPIv1.on('channels/new', (channel, params) => this.emit('v1/channels/new', channel, params));
        this._rpChatsAPIv1.on('channels/edit', (channel, params) => this.emit('v1/channels/edit', channel, params));
        this._rpChatsAPIv1.on('channels/delete', (channel, params) => this.emit('v1/channels/delete', channel, params));
        this._rpChatsAPIv1.on('channels/read', (response, params) => this.emit('v1/channels/read', response, params));
        this._rpChatsAPIv1.on('channels/unread', (response, params) => this.emit('v1/channels/unread', response, params));
        this._rpChatsAPIv1.on('channels/leave', (channel, userId, params) => this.emit('v1/channels/leave', channel, userId, params));
        this._rpChatsAPIv1.on('messages', (messages, page, params) => this.emit('v1/messages', messages, page, params));
        this._rpChatsAPIv1.on('messages/new', (message, params) => this.emit('v1/messages/new', message, params));
        this._rpChatsAPIv1.on('messages/edit', (message, params) => this.emit('v1/messages/edit', message, params));
        this._rpChatsAPIv1.on('messages/delete', (message, params) => this.emit('v1/messages/delete', message, params));
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._rpChatsAPIv1.init();
        });
    }
    deinit() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this._rpChatsAPIv1.deinit();
            }
            catch (error) {
                this.emit('error', error);
            }
        });
    }
    chats({ version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.chats();
            default:
                return null;
        }
    }
    chatsDescribe(chatId, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.chatsDescribe(chatId);
            default:
                return null;
        }
    }
    chatsMembers(chatId, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.chatsMembers(chatId);
            default:
                return null;
        }
    }
    chatsMembersEdit(chatId, membersToAdd, membersToRemove, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.chatsMembersEdit(chatId, membersToAdd, membersToRemove);
            default:
                return null;
        }
    }
    chatsNew(newChat, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.chatsNew(newChat);
            default:
                return null;
        }
    }
    chatsEdit(editChat, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.chatsEdit(editChat);
            default:
                return null;
        }
    }
    chatsDelete(deleteChat, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.chatsDelete(deleteChat);
            default:
                return null;
        }
    }
    channels({ version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channels();
            default:
                return null;
        }
    }
    channelsDescribe(channelId, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsDescribe(channelId);
            default:
                return null;
        }
    }
    channelsMembers(channelId, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsMembers(channelId);
            default:
                return null;
        }
    }
    channelsMembersEdit(channelId, membersToAdd, membersToRemove, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsMembersEdit(channelId, membersToAdd, membersToRemove);
            default:
                return null;
        }
    }
    channelsNew(newChannel, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsNew(newChannel);
            default:
                return null;
        }
    }
    channelsEdit(editChannel, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsEdit(editChannel);
            default:
                return null;
        }
    }
    channelsDelete(deleteChannel, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsDelete(deleteChannel);
            default:
                return null;
        }
    }
    channelsRead(request, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsRead(request);
            default:
                return null;
        }
    }
    channelsUnread({ version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsUnread();
            default:
                return null;
        }
    }
    channelsLeave(request, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.channelsLeave(request);
            default:
                return null;
        }
    }
    messages(request, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.messages(request);
            default:
                return null;
        }
    }
    messagesNew(newMessage, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.messagesNew(newMessage);
            default:
                return null;
        }
    }
    messagesEdit(editChannel, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.messagesEdit(editChannel);
            default:
                return null;
        }
    }
    messagesDelete(deleteChannel, { version } = { version: 'v1' }) {
        switch (version) {
            case 'v1':
                return this._rpChatsAPIv1.messagesDelete(deleteChannel);
            default:
                return null;
        }
    }
}
export { RPChatsAPI };
